export const approveServiceRequestSuccess = 'Successfully approved service request!';
export const sentForReviewSuccess = 'Successfully sent service request for review!';
export const sentToEditorSuccess = 'Successfully sent service request to editor!';
export const statusChangeSuccess = 'Successfully updated service request status';
export const removedSuccess = 'Successfully removed service request';
export const deleteServiceRequestTitle = 'Delete this service request?';
export const deleteServiceRequestDescription = 'This cannot be undone. Are you sure you would like to do this?';
export const deleteServiceRequestButton = 'yes, delete';
export const approveTitle = 'Approve service request';
export const approveSubTitle = "Incorrect files and their status'";
export const selectFileTitle = 'Select a file status you would like these files to go into.';
export const selectStatusPlaceholder = 'select a status...';
export const approveButton = 'approve';
export const changeStatusTitle = 'Change service request status';
export const changeStatusLabel = 'FILE STATUS';
export const changeStatusPlaceholder = 'select a status...';
export const downloadModalTitle = 'Download service request files';
export const downloadModalDescription = 'This will download all the files for each type you select below.';
export const downloadModalIncorrectButton = 'incorrect files';
export const downloadModalRawsButton = 'raws';
export const disabledSendForApprovalMessage = 'You must upload completed files to this service request before sending it for approval.';
export const disabledSendForApprovalMessageAlt = 'You must upload completed files to this service request before approving.';
export const sendForApprovalButton = 'send for approval';
export const sendToEditorButton = 'send to editor';
export const disabledSendToEditorButton = 'You must add an editor to this service request before sending to an editor.';
export const removeHover = 'remove';
export const changeStageHover = 'change stage';
export const settingsButtonAlt = 'more options button';
